import { render, staticRenderFns } from "./BodyDeItem.vue?vue&type=template&id=09c13c97&scoped=true"
import script from "./BodyDeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyDeItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BodyDeItem.vue?vue&type=style&index=0&id=09c13c97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c13c97",
  null
  
)

export default component.exports